import { useState } from "react";
import { ShieldCheck, Flag } from "lucide-react";
import ReportModal from "@/components/ReportModal";

export default function Footer() {
  const [reportOpen, setReportOpen] = useState(false);

  return (
    <footer className="bg-slate-900 text-slate-300 mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-14 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2 mb-4">
            <span className="bg-emerald-600 text-white rounded-xl p-1.5">
              <ShieldCheck className="w-5 h-5" />
            </span>
            <span className="font-heading font-black text-lg text-white">
              Bergerak<span className="text-emerald-400">Nyata</span>
            </span>
          </div>
          <p className="text-sm leading-relaxed text-slate-400 max-w-md">
            Platform civic-tech yang menggerakkan warga Indonesia menuju aksi sosial berdampak tinggi.
            Temukan aksi, komunitas, dan solusi nyata untuk lingkunganmu.
          </p>
        </div>
        <div>
          <h4 className="text-white font-bold text-sm mb-4 uppercase tracking-wider">Platform</h4>
          <ul className="space-y-2 text-sm">
            <li><a href="/jelajahi" className="hover:text-emerald-400 transition-colors">Jelajahi Aksi</a></li>
            <li><a href="/matchmaker" className="hover:text-emerald-400 transition-colors">AI Matchmaker</a></li>
            <li><a href="/solusi" className="hover:text-emerald-400 transition-colors">Solusi Masalah</a></li>
            <li><a href="/organizer" className="hover:text-emerald-400 transition-colors">Organizer Hub</a></li>
          </ul>
        </div>
        <div>
          <h4 className="text-white font-bold text-sm mb-4 uppercase tracking-wider">Pusat Keamanan</h4>
          <button
            data-testid="footer-report-btn"
            onClick={() => setReportOpen(true)}
            className="flex items-center gap-2 bg-rose-600/15 border border-rose-500/40 text-rose-300 px-4 py-2.5 rounded-full text-sm font-bold hover:bg-rose-600/25 transition-colors"
          >
            <Flag className="w-4 h-4" /> Laporkan Masalah / Pengaduan
          </button>
          <p className="text-xs text-slate-500 mt-3 leading-relaxed">
            Darurat? Hubungi Hotline 110 atau Layanan SAPA 129.
          </p>
        </div>
      </div>
      <div className="border-t border-slate-800 py-5 text-center text-xs text-slate-500">
        © 2026 BergerakNyata — Gerakan Warga untuk Indonesia
      </div>
      <ReportModal open={reportOpen} onOpenChange={setReportOpen} targetType="Platform" targetName="Umum" />
    </footer>
  );
}
